import { Component, Input, OnInit } from '@angular/core';
import { FilterMetadata } from 'primeng/api';
import ColumnFilterValueListComponentTemplate from './column-filter-value-list.component.html';

@Component({
  selector: 'd-column-filter-value-list',
  template: ColumnFilterValueListComponentTemplate
})
export class ColumnFilterValueListComponent implements OnInit {
  @Input() field: string;
  @Input() values: any[];
  @Input() filtersOnRow: any;
  @Input() matchMode: string = 'stringIn';

  constructor() { }

  ngOnInit() {
  }

  getModelValue(value: any): any[] | null {
    if (value == null) {
      return null;
    }

    if (Array.isArray(value)) {
      return value;
    }

    if (this.isFilterMetadata(value)) {
      const internal = value.value;
      if (internal == null) {
        return null;
      }
      return Array.isArray(internal) ? internal : [internal];
    }

    return [value];
  }

  private isFilterMetadata(value: any): value is FilterMetadata {
    return !!value && typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'value');
  }
}
